<script>
import StoryIntro from '@/components/cutscenes/StoryIntro'

import music from '@/services/music'

export default {
  name: 'ViewStoryIntro',

  components: {
    StoryIntro
  },

  data () {
    return {
      initialDelayDone: false
    }
  },

  mounted () {
    music.play('ambient1')

    setTimeout(() => {
      this.initialDelayDone = true
    }, 5000)
  },

  methods: {

    advance () {
      this.$store.dispatch('initializeChapterStateFromBeginning', 0)
      this.$router.push({
        name: 'game'
      })
    },

    onComplete () {
      setTimeout(this.advance, 5000)
    }

  }

}
</script>

<template>
  <div class="c-view-story-intro">
    <div class="c-view-story-intro-content">
      <story-intro
        v-if="initialDelayDone"
        @complete="onComplete"
      />
    </div>
  </div>
</template>

<style lang="scss">

.c-view-story-intro-content {
  @include keep-center;
  @include limit-content;
}

</style>
